<template>
    <Button label="Aprovar Justificativa" @click="confirmarAprovacao()" />
</template>

<script>
import Service from './services';

export default {
    emits: ['voltarParaDetalhamento'],

    methods: {
        voltar() {
            this.$emit('voltarParaDetalhamento');
        },

        aprovar() {
            this.$store.dispatch('addRequest');

            Service.aprovarJustificativa(this.$route.params.id).then((response) => {
                if (response && response.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Aprovar Justificativa',
                        detail: 'Justifcativa aprovada com sucesso',
                        life: 3000,
                    });
                    this.$store.dispatch('setAtualizar', true);

                    this.voltar();
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Aprovar Justificativa',
                        detail: 'Erro ao aprovar a justificativa',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
        confirmarAprovacao() {
            this.$confirm.require({
                message: `Tem certeza que deseja aprovar a justificativa?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.aprovar();
                },
            });
        },
    },
};
</script>
